import styled from "styled-components";

export const RewardCheckCodeContainerStyled = styled.div`
  border-radius: 1rem;
  padding: 1.25rem;
  background: ${({ theme }) => theme.COLORS.WHITE_1};
  .block_section {
    margin-bottom: 2rem;
    .title {
      margin-bottom: 23px;
      font-size: ${({ theme }) => theme.FONT.SIZE.S15};
      font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_SEMIBOLD};
    }
  }
  .line {
    margin: 19px 0 21px 0;
    border-bottom: 1px solid ${({ theme }) => theme.COLORS.GRAY_11};
  }
  .body {
    width: 100%;
    display: flex;
    .body_left {
      width: 50%;
      display: flex;
      flex-direction: column;
      white-space: nowrap;
      .body_title {
        font-size: ${({ theme }) => theme.FONT.SIZE.S12};
        font-weight: 600;
      }
      .value_item_wrap {
      }
    }
    .body_right {
      width: 50%;
      white-space: nowrap;
      .body_title {
        font-size: ${({ theme }) => theme.FONT.SIZE.S12};
        font-weight: 600;
      }
      .value_item_wrap {
        flex: 1;
      }
    }
  }
  .filter_wrap {
    margin-bottom: 1rem;
  }
  .body_table {
    margin-bottom: 21px;
  }
  .btn_wrap {
    display: flex;
    justify-content: flex-end;
    .w120 {
      width: 120px;
    }
  }
`;
